// Sidebar.js
import React, { useState, useEffect } from "react";
import { Button, Badge } from "react-bootstrap";
import { FaFilter, FaTimes } from "react-icons/fa";
import "./Sidebar.css";

const Sidebar = ({ 
  categories, 
  activeCategory, 
  onCategorySelect, 
  filteredProductsCount,
  searchQuery,
  getAllProductsCount,
  getCategoryProductCount
}) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Check if scrolled more than 140px
      if (window.pageYOffset > 140) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`sidebar-fixed ${isScrolled ? 'sidebar-scrolled' : ''}`}>
      <div className="sidebar-card">
        <div className="sidebar-header">
          <h5><FaFilter className="me-2" /> Categories</h5>
          {activeCategory !== 'all' && (
            <Button 
              variant="link" 
              size="sm" 
              className="text-decoration-none clear-btn"
              onClick={() => onCategorySelect('all')}
            >
              <FaTimes /> Clear
            </Button>
          )}
        </div>
        <div className="sidebar-body">
          <div 
            className={`category-item ${activeCategory === 'all' ? 'active' : ''}`}
            onClick={() => onCategorySelect('all')}
          >
            <span>All Products</span>
            <Badge className="">{getAllProductsCount()}</Badge>
          </div>
          {categories.map((category) => {
            const count = getCategoryProductCount(category.category_id);
            return (
              <div 
                key={category.category_id}
                className={`category-item ${activeCategory === String(category.category_id) ? 'active' : ''}`}
                onClick={() => onCategorySelect(String(category.category_id))}
              >
                <span>{category.category_name}</span>
                <Badge className="">{count}</Badge>
              </div>
            );
          })}
        </div>

        {/* Quick Stats */}
        <div className="sidebar-stats">
          <div className="stat-item">
            <span>Showing</span>
            <strong>{filteredProductsCount} products</strong>
          </div>
          {searchQuery && (
            <div className="stat-item text-muted">
              <small>Search: "{searchQuery}"</small>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;